import React from 'react';
import { TextField } from '@mui/material';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import BudgetSection from './BudgetSection';
import { roundedFieldSx } from './budgetFormat';

/** Validade (em dias, vira "Válido até <data>" no PDF) e observações do rodapé. */
function BudgetExtraInfo({ validityDays, validUntil, notes, onChange }) {
  return (
    <BudgetSection
      icon={<NotesOutlinedIcon />}
      title="Informações adicionais"
      subtitle="Validade e observações no fim do orçamento."
    >
      <TextField
        label="Validade (dias)"
        size="small"
        fullWidth
        type="number"
        sx={roundedFieldSx}
        inputProps={{ min: 1, step: 1 }}
        value={validityDays}
        onChange={(e) => onChange('validityDays', e.target.value.replace(/\D/g, ''))}
        helperText={validUntil ? `Válido até ${validUntil}` : 'Vazio: o PDF sai sem validade'}
      />
      <TextField
        label="Observações"
        size="small"
        fullWidth
        multiline
        rows={4}
        sx={roundedFieldSx}
        value={notes}
        onChange={(e) => onChange('notes', e.target.value)}
      />
    </BudgetSection>
  );
}

export default BudgetExtraInfo;
